<div class="rounded-lg transition-all ease-in-out duration-300" [style]="getErrorStyle()">
    <div class="w-full flex items-center p-3">
        <span class="dark:text-white leading-7">
          <span *ngIf="questionNumber" class="rtl:ml-1 ltr:mr-1">
            {{questionNumber.toString()|convertToPersian}}.
          </span>
          {{data.text}}
        </span>
        <button *ngIf="config.number_of_permitted_vague_question>0 || config.is_can_comment_on_question" (click)="changeCommentState()" class="rtl:mr-2 ltr:ml-2 flex items-center justify-center h-full aspect-square">
            <mat-icon class="mat-center">
                edit_note
            </mat-icon>
        </button>
    </div>
    <app-expand-sec (dataEmitter)="updateExpandSecData($event)" (commentEmitter)="sendComment()" [showFormObs]="commentStatusObs$" [config]="{isShowUnknown: config.number_of_permitted_vague_question>0, isShowComment: config.is_can_comment_on_question, questionId: data.id, isUnknownInitalValue: isUnknownInital}"></app-expand-sec>
    <div class="w-full relative py-4">
        <div class="w-full flex justify-between px-5 text-sm">
            <div>
                {{data.additional_fields.options_text_on_the_right}}
            </div>
            <div>
                {{data.additional_fields.options_text_on_the_left}}
            </div>
        </div>
        <div #optionListParent class="mx-auto w-full flex items-center justify-center md:justify-center" [style]="'max-width: '+getMaxWidth(data.options.length)+'px;'">
            <div *ngFor="let option of data.options; let i = index" class="aspect-square p-1" [style]="customW[i]">
                <div class="w-full h-full border-[3px] rounded-full overflow-hidden flex items-center justify-center hover:opacity-100 ease-in-out duration-300 cursor-pointer"  [class]="outputData.answer[0]==option.id?'opacity-100':'opacity-60'" [style]="getOptionColorStyle(i, option.id)" (click)="activeOption(option.id)" [id]="i.toString()">
                    <svg *ngIf="outputData.answer[0]==option.id" height="55%" width="55%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                        <path fill="none" stroke="white" stroke-width="10" d="M20 50 L40 70 L80 30"/>
                    </svg>
                    <!-- <mat-icon *ngIf="outputData.answer[0]==option.id" class="mat-center text-white" style="text-shadow: 0px 0px 2px rgb(56, 56, 56);font-size: inherit;">done</mat-icon> -->
                </div>
            </div>
        </div>
        <app-hatch-skin *ngIf="extraData.isUnknown" @hatchFade></app-hatch-skin>
    </div>
</div>
